





















































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ErrorModal extends Vue {
  private retry () {
    // ログアウト処理
    this.$router.push('/login').catch(e => {})
  }
}
